module.exports = __webpack_public_path__ + "static/media/chargixpro-5.ad9b2d6e.jpg";